import { yupResolver } from '@hookform/resolvers/yup';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	IconButton,
} from '@mui/material';
import { useEffect, useState } from 'react';
import {
	DefaultValues,
	FormProvider,
	SubmitHandler,
	useForm,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import Close from '@mui/icons-material/Close';
import AppTextField from '@/common/components/form-inputs/AppTextField';
import CloseIcon from '@mui/icons-material/Close';
import { closeSnackbar, enqueueSnackbar } from 'notistack';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import { useSetSubTitleMutation } from '@/api/common';
import { SetSubTitleDTO } from '@/api/DTO/common.interface';

interface Props {
	informationTypeData: any;
}

export default function SetSubTitleDialog(props: Props) {
	const { informationTypeData } = props;
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const [SetSubTitle] = useSetSubTitleMutation();
	const defaultValues: DefaultValues<SetSubTitleDTO> = {
		subtitleZh: informationTypeData?.data.subtitleZh,
		subtitleEn: informationTypeData?.data.subtitleEn,
	};

	useEffect(() => {
		if (informationTypeData) {
			methods.reset({
				subtitleZh: informationTypeData?.data.subtitleZh,
				subtitleEn: informationTypeData?.data.subtitleEn,
			});
		}
	}, [informationTypeData]);

	const formSchema = Yup.object().shape({});

	const methods = useForm<SetSubTitleDTO>({
		defaultValues,
		resolver: yupResolver(formSchema),
	});

	const handleClose = () => {
		methods.reset();
		setOpen(false);
	};

	const onSubmit: SubmitHandler<SetSubTitleDTO> = async (data) => {
		const response = await SetSubTitle({
			...data,
			id: informationTypeData.data.id,
		});
		if ('data' in response) {
			enqueueSnackbar(t('snackbar.changeSubTitleSuccess'), {
				variant: 'success',
				anchorOrigin: { horizontal: 'center', vertical: 'top' },
				autoHideDuration: 3000,
				action: (key) => {
					return <CloseIcon onClick={() => closeSnackbar(key)} />;
				},
			});
			handleClose();
		}
	};

	return (
		<>
			<IconButton
				color='primary'
				onClick={() => {
					setOpen(true);
				}}
			>
				<CreateOutlinedIcon />
			</IconButton>

			<Dialog
				open={open}
				onClose={() => handleClose()}
				aria-labelledby='alert-dialog-title'
				aria-describedby='alert-dialog-description'
				maxWidth='xs'
				fullWidth
			>
				<DialogTitle variant='h5'>{t('aboutUs.changeSubTitle')}</DialogTitle>
				<IconButton
					aria-label='close'
					onClick={() => handleClose()}
					sx={{
						position: 'absolute',
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}
				>
					<Close />
				</IconButton>
				<DialogContent>
					<FormProvider {...methods}>
						<form onSubmit={methods.handleSubmit(onSubmit)}>
							<Grid container spacing={2} marginTop={0}>
								<Grid item xs={12}>
									<AppTextField
										control={methods.control}
										name='subtitleZh'
										label={t('aboutUs.subTitleZh_')}
										maxLength={20}
									/>
								</Grid>
								<Grid item xs={12}>
									<AppTextField
										control={methods.control}
										name='subtitleEn'
										label={t('aboutUs.subTitleEn_')}
										maxLength={100}
									/>
								</Grid>
							</Grid>
						</form>
					</FormProvider>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => handleClose()}>{t('button.cancel')}</Button>
					<Button
						type='submit'
						variant='contained'
						onClick={methods.handleSubmit(onSubmit)}
					>
						{t('button.isConfirm')}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}
